import React, { useEffect, useState } from "react";
// import "./redirect.css";
import { Box } from "./redirectStyle";
import { isInIframe } from "../../utils/is-in-iframe";
import { ToolsHeader } from "../components/ToolsHeader";

const validateUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

//   const urlObj = new URL(url);
//   const isHttps = urlObj.protocol === "https:";
//   const isWww = urlObj.hostname.startsWith("www.");

//   const redirects: Redirect[] = [];
//   redirects.push({
//     url,
//     status: isHttps ? 200 : 301,
//     https: isHttps,
//     headers: {
//       Server: "nginx/1.18.0",
//       Date: new Date().toUTCString(),
//       "Content-Type": "text/html",
//       ...(isHttps
//         ? {}
//         : {
//             Location: `https://${urlObj.host}${urlObj.pathname}`,
//             Connection: "keep-alive",
//           }),
//     },
//   });

//   if (!isWww) {
//     redirects.push({
//       url: `${urlObj.protocol}//www.${urlObj.host}${urlObj.pathname}`,
//       status: 301,
//       https: isHttps,
//       headers: {
//         Server: "nginx/1.18.0",
//         Date: new Date().toUTCString(),
//         "Content-Type": "text/html",
//         Location: `${urlObj.protocol}//www.${urlObj.host}${urlObj.pathname}`,
//         Connection: "keep-alive",
//       },
//     });
//   }

//   if (!isHttps || !isWww) {
//     redirects.push({
//       url: `https://www.${urlObj.host}${urlObj.pathname}`,
//       status: 200,
//       https: true,
//       headers: {
//         Server: "nginx/1.18.0",
//         Date: new Date().toUTCString(),
//         "Content-Type": "text/html; charset=utf-8",
//         "Cache-Control": "max-age=3600",
//         "X-Frame-Options": "SAMEORIGIN",
//         "X-Content-Type-Options": "nosniff",
//       },
//     });
//   }

//   let score = 100;
//   score -= (redirects.length - 1) * 5;
//   if (!isHttps) score -= 10;
//   if (!isWww) score -= 5;

//   return { redirects, score };
// };

const RedirectChecker: React.FC = () => {
  const [url, setUrl] = useState("");
  const [newRedirects, setNewRedirects] = useState<
    {
      url: string;
      statusCode: number;
      redirectNot: string;
      redirects: number;
      finalUrl: string;
      finalUrlStatusCode: number;
    }[]
  >([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const checkRedirects = async (url: string) => {
    try {
      const baseUrl = process.env.REACT_APP_BASE_API;
      const response = await fetch(`${baseUrl}/api/site-map/website-checker`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: url }),
      });

      const data = await response.json();
      if (data.success === false) {
        setError("URL not found");
        const height = document.body.scrollHeight;
        window.parent.postMessage({ type: "setHeight", height }, "*");
      } else if (response.status === 200 && data.redirects) {
        const findSameUrl = data.redirects.find(
          (x: any) => x.url === data.startUrl
        );
        const finalSameUrl = data.redirects.find(
          (x: any) => x.url === data.finalUrl
        );
        const collectData = [
          {
            url: data.startUrl,
            statusCode: findSameUrl.status,
            redirectNot: findSameUrl.status !== 200 ? "Needs check" : "Ok",
            redirects: findSameUrl.status === 200 ? 0 : 1,
            finalUrl: data.finalUrl,
            finalUrlStatusCode: finalSameUrl.status,
          },
        ];
        // console.log("collectData----", collectData);
        setNewRedirects(collectData);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (!validateUrl(url)) {
      setError("Please enter a valid URL including http:// or https://");
      return;
    }
    setLoading(true);
    await checkRedirects(url);

    setLoading(false);
    const height = document.body.scrollHeight;
    window.parent.postMessage({ type: "setHeight", height }, "*");
  };

  useEffect(() => {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ type: "setHeight", height }, "*");
  }, [newRedirects, error]);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const inputUrl = params.get("url");
    if (inputUrl) {
      setUrl(inputUrl);
      setTimeout(() => handleSubmit(new Event("submit") as any), 0);
    }
  }, []);

  return (
    <Box
      className={`${!isInIframe ? "py-5 defaultText" : "py-1 interDisplay"}`}
    >
      <div className="container container-redirect">
        {!isInIframe && (
          <ToolsHeader
            title="Website Redirect Checker"
            description="Analyze your website's redirect chain and optimize it to improve
                overall performance."
          />
        )}
        {/* <div className="header">
          <h1>Website Redirect Checker</h1>
          <p>
            Analyze your website's redirect chain and optimize for better
            performance
          </p>
        </div> */}
        <form onSubmit={handleSubmit} className="url-form">
          <div className="input-group-box">
            <input
              type="text"
              className="input_checker"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Enter URL (e.g., https://example.com)"
              required
            />
            <button type="submit" disabled={loading} className="checker_button" style={{ backgroundColor: loading ? "#ccc" : "#8cc540" }}>
              {loading ? "Checking..." : "Check Redirects"}
              <span className="spinner hidden"></span>
            </button>
          </div>
          {error && <div className="error-message">{error}</div>}
        </form>

        {newRedirects.length > 0 && (
          <div className="card">
            <h2>Result</h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>URL</th>
                    <th>STATUS CODE</th>
                    <th>REDIRECT NOTE</th>
                    <th>REDIRECTS</th>
                    <th>FINAL URL</th>
                    <th>FINAL URL STATUS CODE</th>
                  </tr>
                </thead>
                <tbody>
                  {newRedirects.map((r, i) => (
                    <tr key={i}>
                      <td>{r.url}</td>
                      {/* <td>{r.statusCode}</td> */}
                      <td>
                        <span
                          className={`status-code ${
                            r.statusCode === 200 ? "success" : "redirect"
                          }`}
                        >
                          {r.statusCode}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`status-code ${
                            r.redirectNot.toLowerCase() === "ok"
                              ? "success"
                              : "error"
                          }`}
                        >
                          {r.redirectNot}
                        </span>
                      </td>
                      <td>
                        <span className={`status-code ${"success"}`}>
                          {r.redirects}
                        </span>
                      </td>
                      <td>{r.finalUrl}</td>
                      <td>
                        <span
                          className={`status-code ${
                            r.finalUrlStatusCode === 200
                              ? "success"
                              : "redirect"
                          }`}
                        >
                          {r.finalUrlStatusCode}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </Box>
  );
};

export default RedirectChecker;
